<template>
	<el-card class="shipbox" shadow="never">
		<div slot="header" class="flexBetween">
			<h3>收货信息</h3>
			<div class="tit-btn">
				<el-button icon="el-icon-refresh" type="text" @click="refresh" v-click-once>刷新</el-button>
				<el-button icon="el-icon-circle-plus-outline" type="text" @click="addInfo">使用新地址</el-button>
				<el-button type="text" @click="handleGoAddress">管理地址</el-button>
			</div>
		</div>
		<div class="shiplist">
			<transition-group name="fade-list" tag="el-row">
				<el-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24" v-for="(item, index) in visibleItems" :key="item.id">
					<div :class="item.checked ? 'selected' : ''" class="shipitem flex" @click.stop="toggleSelected(item, index)">
						<el-checkbox v-model="item.checked"></el-checkbox>
						<div style="flex: 1; margin-left: 18px; overflow: hidden">
							<div class="region" :title="item.provinceName + item.cityName + item.districtName">
								<span v-if="item.isDefault" class="tagbg tagred" type="text">默认</span>
								<span>{{ item.provinceName }}{{ item.cityName }}{{ item.districtName }}</span>
							</div>
							<div class="address" :title="item.detailAddress">{{ item.detailAddress }}</div>
							<div class="uinfo">
								{{ item.receiverName }}
								&nbsp;
								{{ item.receiverPhone }}
							</div>
							<div class="button-box" @click.stop="modifyInfo(item)">编辑</div>
						</div>
					</div>
				</el-col>
			</transition-group>
			<!-- 展开/收起按钮 -->
			<div v-if="shouldShowToggle" class="expand-toggle" @click="toggleExpand">
				<el-button type="text" size="small">
					<i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
					{{ toggleButtonText }}
				</el-button>
			</div>
		</div>
		<!--    新增收货地址-->
		<DialogAddress
			ref="DialogAddressRef"
			:dialogTitle="dialogTitle"
			:dialogVisible="dialogVisible"
			:form="form"
			:rules="rules"
			@addConfirmInfo="addConfirmInfo"
			@cancel="dialogVisible = false"
			@modifyConfirmInfo="modifyConfirmInfo"
		/>
	</el-card>
</template>

<script>
import Y from '@/utils/Y';
import DialogAddress from '@/views/UserCenter/components/DialogAddress.vue';
import { getCorporateGetAddress, deleteCorporateRemoveAddress, postCorporateUpdateAddress, postCorporateAddAddress } from '@/api/user/address';
import mtils from 'mtils';
import bus from '@/bus';
export default {
	data() {
		//校验 手机号码
		const validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('收货人手机号码不可为空'));
			}
			if (!mtils.validation.isMobile(value)) {
				return callback(new Error('收货人手机号码格式不正确'));
			}
			callback();
		};
		return {
			list: [],
			bodystyle: { padding: '0px' },

			// 折叠相关状态
			isExpanded: false, // 是否展开
			itemsPerRow: 4, // 每行显示的项目数
			maxRows: 1, // 最大显示行数

			dialogTitle: '新增收货地址',
			dialogVisible: false,
			form: {
				receiverName: '',
				receiverPhone: '',
				provinceName: '',
				cityName: '',
				districtName: '',
				detailAddress: '',
				isDefault: 0
			},
			rules: {
				receiverName: [
					{
						required: true,
						message: '收货人姓名不可为空',
						trigger: 'blur'
					}
				],

				receiverPhone: [
					{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}
				],

				detailAddress: [
					{
						required: true,
						message: '详细地址不可为空',
						trigger: 'blur'
					}
				],

				provinceName: [
					{
						required: true,
						message: '所属省不可为空',
						trigger: 'change'
					}
				],

				cityName: [
					{
						required: true,
						message: '所属市不可为空',
						trigger: 'change'
					}
				],

				districtName: [
					{
						required: true,
						message: '所属区不可为空',
						trigger: 'change'
					}
				]
			}
		};
	},
	computed: {
		// 计算是否显示折叠按钮
		shouldShowToggle() {
			return this.list.length > this.itemsPerRow * this.maxRows;
		},

		// 计算可见的项目
		visibleItems() {
			if (this.isExpanded || !this.shouldShowToggle) {
				return this.list;
			}
			return this.list.slice(0, this.itemsPerRow * this.maxRows);
		},

		// 计算折叠按钮文本
		toggleButtonText() {
			if (this.isExpanded) {
				return '收起';
			} else {
				const hiddenCount = this.list.length - this.itemsPerRow * this.maxRows;
				return `展开全部(${this.list.length})` + (hiddenCount > 0 ? ` 还有${hiddenCount}个地址` : '');
			}
		}
	},
	components: {
		DialogAddress
	},
	created() {
		this.getCorporateGetAddress(0);
		this.updateItemsPerRow();
		window.addEventListener('resize', this.updateItemsPerRow);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateItemsPerRow);
	},
	methods: {
		// 更新每行显示的项目数
		updateItemsPerRow() {
			const width = window.innerWidth;
			// 根据Element UI的响应式断点
			if (width >= 1920) {
				this.itemsPerRow = 3; // xl: 24/6 = 4个
			} else if (width >= 1367) {
				this.itemsPerRow = 2; // lg: 24/8 = 3个
			} else if (width >= 992) {
				this.itemsPerRow = 2; // md: 24/12 = 2个
			} else {
				this.itemsPerRow = 1; // sm, xs: 24/24 = 1个
			}

			// 如果当前显示的项目数超过了新的限制，需要重置展开状态
			if (!this.isExpanded && this.list.length > this.itemsPerRow * this.maxRows) {
				// 保持收起状态
			} else if (this.isExpanded && this.list.length <= this.itemsPerRow * this.maxRows) {
				// 如果展开后项目数小于等于新的限制，自动收起
				this.isExpanded = false;
			}
		},

		// 切换展开/收起状态
		toggleExpand() {
			this.isExpanded = !this.isExpanded;
		},

		refresh() {
			this.getCorporateGetAddress(0);
		},

		handleGoAddress() {
			const targetRoute = this.$router.resolve({
				path: '/UserCenter/UserAddress'
			});
			window.open(targetRoute.href, '_blank');
		},

		toggleSelected(item, index) {
			if (this.list.length > 1) {
				this.list.forEach(item => {
					item.checked = false;
				});
			}
			item.checked = !item.checked;
			this.$set(this.list, index, item);
			bus.$emit('selectAddress', item);
		},

		//获取收货地址列表
		async getCorporateGetAddress(type) {
			const res = await getCorporateGetAddress({});
			this.list = res.data.rows;
			this.list.forEach(item => {
				item.checked = item.isDefault ? true : false;
			});
			const isDefault = this.list.find(item => item.isDefault);
			// 如果没有默认地址，默认选择第一个
			//如果有默认地址，默认选择默认地址
			if (!isDefault) {
				this.list[0].checked = true;
				bus.$emit('selectAddress', this.list[0]);
			} else {
				bus.$emit('selectAddress', isDefault);
			}
		},

		//确认添加收货地址
		addConfirmInfo(val) {
			//判断，如果list 是空，默认设置为默认地址
			if (this.list.length === 0) {
				val.isDefault = 1;
			} else {
				val.isDefault = 0;
			}
			postCorporateAddAddress(val)
				.then(res => {
					Y.msg.success('收货地址保存成功！');
					this.dialogVisible = false;
					this.getCorporateGetAddress(1);
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		//确认修改收货地址
		modifyConfirmInfo(val) {
			postCorporateUpdateAddress(val)
				.then(res => {
					Y.msg.success('收货地址修改成功！');
					this.dialogVisible = false;
					this.getCorporateGetAddress();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		// 添加收货地址
		addInfo() {
			this.form = {};
			this.dialogTitle = '新增收货地址';
			this.dialogVisible = true;
		},

		// 编辑收货地址
		modifyInfo(item) {
			this.form = {
				id: item.id,
				receiverName: item.receiverName,
				receiverPhone: item.receiverPhone,
				provinceName: item.provinceName,
				cityName: item.cityName,
				districtName: item.districtName,
				detailAddress: item.detailAddress,
				isDefault: item.isDefault ? 1 : 0
			};
			this.dialogTitle = '修改收货地址';
			this.dialogVisible = true;
		},

		// 删除收货地址
		removeInfo(id) {
			Y.confirm('确认删除此收货地址吗？').then(rlt => {
				if (rlt.confirm) {
					deleteCorporateRemoveAddress(id)
						.then(res => {
							Y.msg.success('收货地址删除成功！');
							this.getCorporateGetAddress();
						})
						.catch(err => {
							Y.msg.error(err.message);
						});
				}
			});
		},

		setDefault(sid) {
			Y.confirm('确认修改默认收货地址吗？').then(rlt => {
				if (rlt.confirm) {
					Y.msg.success('恭喜！修改成功');
				}
			});
		}
	}
};
</script>
<style lang="less" scoped>
.shipbox {
	margin-bottom: 20px;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	h3 {
		margin: 0;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
	}
	button + button {
		margin-left: 20px;
	}
}
.shiplist {
	flex-wrap: wrap;
	margin-left: -10px;
	margin-right: -10px;
	transition: max-height 0.5s ease;
	overflow: hidden;

	.selected {
		border: 1px solid #1474e2;
	}

	// 展开/收起按钮样式
	.expand-toggle {
		text-align: center;
		margin-top: 15px;
		padding: 10px 0;
		border-top: 1px solid #eee;

		.el-button {
			color: #1474e2;
			font-size: 14px;

			&:hover {
				color: #0d5bb9;
			}

			i {
				margin-right: 5px;
				transition: transform 0.3s ease;
			}
		}
	}
}

// 列表项过渡动画
.fade-list-enter-active,
.fade-list-leave-active {
	transition: all 0.3s ease;
}
.fade-list-enter,
.fade-list-leave-to {
	opacity: 0;
	transform: translateY(10px);
}

.shipitem {
	cursor: pointer;
	margin: 0 10px 20px 10px;
	padding: 20px;
	border: 1px solid #cccccc;
	border-radius: 3px;
	color: #333333;
	font-size: 14px;
	line-height: 1.8;
	flex: 0 1 23.8%;
	box-sizing: border-box;
	transition: all 0.3s ease;

	.address {
		margin-bottom: 5px;
		font-weight: bold;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.region {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		span + span {
			margin-left: 5px;
		}
	}
	.button-box {
		text-align: right;
		color: #ec2b2d;
		visibility: hidden;
		cursor: pointer;
	}
}
.shipitem:nth-child(4n) {
	margin-right: 0;
}
.shipitem:hover .button-box {
	visibility: visible;
}
/deep/ .el-card__header {
	padding: 30px 30px 0;
	border-bottom: none;
}
/deep/ .el-card__body,
.el-main {
	padding: 20px 30px;
}
/deep/ .el-button--text {
	color: #333333;
	padding: 0;
}
/deep/ .el-button--text:hover {
	color: #1474e2;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.shipitem {
		margin-right: 0;
		flex: 0 1 100%;
	}
	.shiplist .expand-toggle {
		margin-top: 10px;
		padding: 8px 0;
	}
}
@media screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
	.shipitem {
		margin-right: 20px;
		flex: 0 1 48.5%;
	}
	.shipitem:nth-child(2n) {
		margin-right: 0;
	}
	.shiplist .expand-toggle {
		margin-top: 12px;
		padding: 8px 0;
	}
}

// 移动端适配
@media screen and (max-width: 767px) {
	.shiplist .expand-toggle {
		margin-top: 8px;
		padding: 6px 0;

		.el-button {
			font-size: 13px;
		}
	}
}
</style>
